import { isAfter, isBefore, isSameDay } from 'date-fns'
import { AsyncValidateCallback, FormErrors } from 'redux-form'
import { isEmpty } from 'lodash'
import { IFilterRoomsValues } from './withReduxForm'

export default function() {
  return function({
    dateFrom,
    dateTo,
  }: IFilterRoomsValues): Promise<FormErrors<IFilterRoomsValues, string>> {
    return new Promise<FormErrors<IFilterRoomsValues, string>>(
      (resolve, reject) => {
        const errors: FormErrors<IFilterRoomsValues, string> = {}

        if (dateFrom !== undefined) {
          if (dateTo === undefined) {
            errors.dateTo = 'reservation_no_date_error'
          }
          if (isSameDay(dateTo, dateFrom)) {
            errors.dateTo = 'reservation_error_end_date_before_start_date'
            errors.dateFrom = 'reservation_error_end_date_before_start_date'
          }
          if (isBefore(dateTo, dateFrom)) {
            errors.dateTo = 'reservation_error_end_date_before_start_date'
          }
        }

        if (dateTo !== undefined) {
          if (dateFrom === undefined) {
            errors.dateFrom = 'reservation_no_date_error'
          }
          if (isSameDay(dateTo, dateFrom)) {
            errors.dateTo = 'reservation_error_end_date_before_start_date'
            errors.dateFrom = 'reservation_error_end_date_before_start_date'
          }
          if (isAfter(dateFrom, dateTo)) {
            errors.dateFrom = 'reservation_error_end_date_before_start_date'
          }
        }

        if (!isEmpty(errors)) {
          reject(errors)
        } else {
          resolve(errors)
        }
      },
    )
  }
}

export function shouldAsyncValidate(
  params: AsyncValidateCallback<IFilterRoomsValues, string>,
): boolean {
  return params.trigger === 'submit' && params.trigger !== undefined
}
